"use strict";
/**
 * Flex styles
 *
 * @author Dominique Rau [domi.github@gmail.com](mailto:domi.github@gmail.com)<br/>
 * @version 0.0.1
 */
Object.defineProperty(exports, "__esModule", { value: true });
// yoga
const column = {
    display: 'flex',
    flexDirection: 'column',
};
const row = {
    display: 'flex',
    flexDirection: 'row',
};
// alignment
const align = {
    center: { alignItems: 'center' },
    start: { alignItems: 'flex-start' },
    end: { alignItems: 'flex-end' },
    strech: { alignItems: 'strech' },
};
// justify
const justify = {
    center: { justifyContent: 'center' },
    spaceBetween: { justifyContent: 'space-between' },
    spaceAround: { justifyContent: 'space-around' },
    spaceEvenly: { justifyContent: 'space-evenly' },
    start: { justifyContent: 'flex-start' },
    end: { justifyContent: 'flex-end' },
};
// grow
const grow = {
    one: { flexGrow: 1 },
    none: { flexGrow: 0 },
};
// shrink
const shrink = {
    one: { flexShrink: 1 },
    none: { flexShrink: 0 },
};
// flex
const flex = {
    flex: 1,
};
// wrap
const wrap = {
    normal: {
        flexWrap: 'wrap',
    },
    reverse: {
        flexWrap: 'wrap-reverse',
    },
    none: {
        flexWrap: 'nowrap',
    },
};
// utils
exports.utils = {
    column: {
        center: Object.assign({}, column, align.center),
        centerCenter: Object.assign({}, column, align.center, justify.center),
    },
    row: {
        bottom: Object.assign({}, row, align.end),
        center: Object.assign({}, row, align.center),
        centerCenter: Object.assign({}, row, align.center, justify.center),
        strech: Object.assign({}, row, align.strech),
        strechbetween: Object.assign({}, row, align.strech, justify.spaceBetween),
        strechCenter: Object.assign({}, row, align.strech, justify.center),
    },
};
exports.yoga = {
    column: column,
    row: row,
    align: align,
    justify: justify,
    flex: flex,
    utils: exports.utils,
    grow: grow,
    shrink: shrink,
    wrap: wrap,
};
exports.default = exports.yoga;
